import React from 'react'

const WorkflowAutomation = () => {
  const NavigateToWorkflow = () => {
    // Open URL in a new tab when the button is clicked
    window.open('https://demoserver.botgo.io/workflow-service/', '_blank', 'noopener,noreferrer')
  }

  return (
    <div
      className='card m-1 text-decoration-none align-items-center text-center'
      style={{
        width: '20rem',
        overflow: 'hidden',
        boxShadow: 'rgb(204, 204, 204) 2px 2px 9px',
        transform: 'scale(1)'
      }}
    >
      <img
        className='mt-4 w-100px h-100px'
        src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ13iQieD6kwDu5jppoYfqdEaOpZoB_j_VbYA&s' // New logo
        alt='Workflow Automation Logo'
      />
      <div className='card-body align-items-center text-center'>
        <h5 className='card-title text-dark'>Workflow Automation</h5>
        <p className='card-text text-muted'>
          Streamline repetitive tasks and automate business workflows effortlessly using our
          intuitive workflow builder.
        </p>
        <button className='btn btn-primary' onClick={NavigateToWorkflow}>
          Create workflow
        </button>
      </div>
    </div>
  )
}

export default WorkflowAutomation
